import DashSide from '../components/DashSide';
import React, { useEffect, useState } from 'react'
import DashboardContent from '../components/DashboardContent';
import UsersPage from '../components/UsersPage';
import MessagesPage from '../components/MessagesPage';
import HomePage from '../components/HomePage';
import Contact from '../components/Contact';
import Agent from '../components/Agent';
import Setting from '../components/Setting';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';


const AdminDashboard = () => {
  const [activePage, setActivePage] = useState('dashboard');
  const authUser = useSelector((state) => state.user.authUser);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!authUser) {
      navigate("/login");
    }
  }, [authUser, navigate]);

  useEffect(() => {
    if (location.state?.resetPage) {
      setActivePage('dashboard');
      // Clear the navigation state
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [location.state]);


  return (
  

<div className="flex w-screen bg-gray-100 h-screen overflow-hidden">
<DashSide  className={activePage === 'livechat' ? 'hidden md:block' : ''} onNavigate={setActivePage} activePage={activePage} authUser={authUser} />
<div className="flex-1 flex flex-col overflow-y-auto">
  {activePage === 'dashboard' && (
    <DashboardContent setActivePage={setActivePage} />  // Pass setActivePage as prop
  )}
  {activePage === 'users' && <UsersPage />}
  {activePage === 'messages' && <MessagesPage />}
  {activePage === 'livechat' && <HomePage />}
  {activePage === 'contacts' && <Contact />}
  {activePage === 'agents' && <Agent />}
  {activePage === 'setting' && <Setting />}
</div>
</div>
  );
};

export default AdminDashboard;